import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAVBAR_HEIGHT = 52;

export default function Navbar() {
  const { user, loading, signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/', { replace: true });
  }

  return (
    <nav
      style={{
        height: NAVBAR_HEIGHT,
        background: 'var(--color-navy)',
        color: 'var(--color-white)',
        padding: '0 var(--space-6)',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid var(--color-navy-border)',
        flexShrink: 0,
      }}
    >
      <NavLink
        to="/"
        style={{
          color: 'var(--color-white)',
          textDecoration: 'none',
          fontFamily: 'var(--font-display)',
          fontSize: 'var(--text-xl)',
          fontWeight: 'var(--weight-bold)',
          letterSpacing: 'var(--tracking-wide)',
          textTransform: 'uppercase',
        }}
      >
        Rentava
      </NavLink>

      <div
        style={{
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--space-3)',
        }}
      >
        {loading ? null : user ? (
          <>
            <span
              style={{
                color: 'var(--color-steel-lt)',
                fontSize: 'var(--text-base)',
                fontFamily: 'var(--font-body)',
              }}
            >
              {user.email}
            </span>
            <button
              type="button"
              onClick={handleSignOut}
              className="btn btn-secondary btn-sm"
            >
              Sign out
            </button>
          </>
        ) : (
          <NavLink to="/login" className="btn btn-primary btn-sm">
            Sign in
          </NavLink>
        )}
      </div>
    </nav>
  );
}
